import { Dispatch, Action } from 'redux';
import axios from 'axios';
import { Company } from '../reducers/companies.reducer'
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
// import { NotificationManager } from 'react-notifications';
import { getCompanyAPI, getCompaniesAPI, addCompanyAPI, editCompanyAPI, deleteCompanyAPI, addCompanySubscriptionAPI, editCompanySubscriptionAPI,
  getCompaniesListAPI,
  editApiCompanySubscriptionAPI,
  addApiCompanySubscriptionAPI} from '../../config/config'
import { getEndofTheDate, getFirstOfTheDate } from '../../utils/timezone';


// Action types
export const GET_COMPANIES_REQUEST = 'GET_COMPANIES_REQUEST';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_FAILURE = 'GET_COMPANIES_FAILURE';

export const GET_COMPANIES_LIST_REQUEST = 'GET_COMPANIES_LIST_REQUEST';
export const GET_COMPANIES_LIST_SUCCESS = 'GET_COMPANIES_LIST_SUCCESS';
export const GET_COMPANIES_LIST_FAILURE = 'GET_COMPANIES_LIST_FAILURE';

export const GET_COMPANY_REQUEST = 'GET_COMPANY_REQUEST';
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS';
export const GET_COMPANY_FAILURE = 'GET_COMPANY_FAILURE';

export const ADD_COMPANY_REQUEST = 'ADD_COMPANY_REQUEST';
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS';
export const ADD_COMPANY_FAILURE = 'ADD_COMPANY_FAILURE';

export const EDIT_COMPANY_REQUEST = 'EDIT_COMPANY_REQUEST';
export const EDIT_COMPANY_SUCCESS = 'EDIT_COMPANY_SUCCESS';
export const EDIT_COMPANY_FAILURE = 'EDIT_COMPANY_FAILURE';

export const DELETE_COMPANY_REQUEST = 'DELETE_COMPANY_REQUEST';
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY_SUCCESS';
export const DELETE_COMPANY_FAILURE = 'DELETE_COMPANY_FAILURE';
export const SET_DELETE_COMPANY_POPUP = 'SET_DELETE_COMPANY_POPUP';
interface AddCompanyProps {
  team_name: string;
  access_type: 'PRIVATE' | 'PUBLIC';
  validation_limit: number;
}

interface DeleteCompanyProps {
  target: string | number;
}
interface GetFilteredCompaniesSuccess extends Action<typeof GET_COMPANIES_SUCCESS> {
  payload: {companies: Company[], totalCount: number, page: number}
}
interface GetCompaniesRequest extends Action<typeof GET_COMPANIES_REQUEST> { }
interface GetCompaniesSuccess extends Action<typeof GET_COMPANIES_SUCCESS> {
  payload: { companies: Company[], totalCount: 0, page: 0 }
}
interface GetCompaniesFailure extends Action<typeof GET_COMPANIES_FAILURE> {
  payload: string
}


interface GetCompaniesListRequest extends Action<typeof GET_COMPANIES_LIST_REQUEST> { }
interface GetCompaniesListSuccess extends Action<typeof GET_COMPANIES_LIST_SUCCESS> {
  payload: { companies: Company[], }
}
interface GetCompaniesListFailure extends Action<typeof GET_COMPANIES_LIST_FAILURE> {
  payload: string
}


interface GetCompanyRequest extends Action<typeof GET_COMPANY_REQUEST> { }
interface GetCompanySuccess extends Action<typeof GET_COMPANY_SUCCESS> {
  payload: Company
}
interface GetCompanyFailure extends Action<typeof GET_COMPANY_FAILURE> {
  payload: string
}

interface AddCompanyRequest extends Action<typeof ADD_COMPANY_REQUEST> { }
interface AddCompanySuccess extends Action<typeof ADD_COMPANY_SUCCESS> { }
interface AddCompanyFailure extends Action<typeof ADD_COMPANY_FAILURE> {
  payload: string
}

interface EditCompanyRequest extends Action<typeof EDIT_COMPANY_REQUEST> { }
interface EditCompanySuccess extends Action<typeof EDIT_COMPANY_SUCCESS> { }
interface EditCompanyFailure extends Action<typeof EDIT_COMPANY_FAILURE> {
  payload: string
}

interface DeleteCompanyRequest extends Action<typeof DELETE_COMPANY_REQUEST> { }
interface DeleteCompanySuccess extends Action<typeof DELETE_COMPANY_SUCCESS> { }
interface DeleteCompanyFailure extends Action<typeof DELETE_COMPANY_FAILURE> {
  payload: string
}

interface SetDeleteCompanyPopUp extends Action<typeof SET_DELETE_COMPANY_POPUP> {
  payload: boolean;
}


export type ActionTypes = GetCompaniesRequest | GetCompaniesSuccess | GetCompaniesFailure
  | GetCompaniesListRequest | GetCompaniesListSuccess | GetCompaniesListFailure
  | GetCompanyRequest | GetCompanySuccess | GetCompanyFailure
  | AddCompanyRequest | AddCompanySuccess | AddCompanyFailure
  | EditCompanyRequest | EditCompanySuccess | EditCompanyFailure
  | DeleteCompanyRequest | DeleteCompanySuccess | DeleteCompanyFailure | SetDeleteCompanyPopUp

// Action creators
const getCompaniesRequest = (): GetCompaniesRequest => ({ type: GET_COMPANIES_REQUEST });
const getCompaniesSuccess = (data: Company[], totalCount: number, page: number): GetFilteredCompaniesSuccess => ({ type: GET_COMPANIES_SUCCESS, payload: {companies: data, totalCount, page } });
const getCompaniesFailure = (error: string): GetCompaniesFailure => ({ type: GET_COMPANIES_FAILURE, payload: error });

const getCompaniesListRequest = (): GetCompaniesListRequest => ({ type: GET_COMPANIES_LIST_REQUEST });
const getCompaniesListSuccess = (data: Company[]): GetCompaniesListSuccess => ({ type: GET_COMPANIES_LIST_SUCCESS, payload: {companies: data } });
const getCompaniesListFailure = (error: string): GetCompaniesListFailure => ({ type: GET_COMPANIES_LIST_FAILURE, payload: error });

const getCompanyRequest = (): GetCompanyRequest => ({ type: GET_COMPANY_REQUEST });
const getCompanySuccess = (data: Company): GetCompanySuccess => ({ type: GET_COMPANY_SUCCESS, payload: data });
const getCompanyFailure = (error: string): GetCompanyFailure => ({ type: GET_COMPANY_FAILURE, payload: error });

const addCompanyRequest = (): AddCompanyRequest => ({ type: ADD_COMPANY_REQUEST });
const addCompanySuccess = (): AddCompanySuccess => ({ type: ADD_COMPANY_SUCCESS });
const addCompanyFailure = (error: string): AddCompanyFailure => ({ type: ADD_COMPANY_FAILURE, payload: error });

const editCompanyRequest = (): EditCompanyRequest => ({ type: EDIT_COMPANY_REQUEST });
const editCompanySuccess = (): EditCompanySuccess => ({ type: EDIT_COMPANY_SUCCESS });
const editCompanyFailure = (error: string): EditCompanyFailure => ({ type: EDIT_COMPANY_FAILURE, payload: error });

const deleteCompanyRequest = (): DeleteCompanyRequest => ({ type: DELETE_COMPANY_REQUEST });
const deleteCompanySuccess = (): DeleteCompanySuccess => ({ type: DELETE_COMPANY_SUCCESS });
const deleteCompanyFailure = (error: string): DeleteCompanyFailure => ({ type: DELETE_COMPANY_FAILURE, payload: error });
const setDeleteCompanyPopup = (value: boolean): SetDeleteCompanyPopUp => ({ type: SET_DELETE_COMPANY_POPUP, payload: value });



// Async action creators
const getCompanies = (params?:any) => {
  return async (dispatch: Dispatch) => {
    try {
      let query = ''
      if(params){
          Object.keys(params)?.map((key, i)=>{
              if(i===0){
                  query = `?${key}=${params[key]}`
              }else{
                  query = query + `&${key}=${params[key]}`
              }
          })
      }
       
      if(params?.page <= 0){
        dispatch(getCompaniesRequest());
      }

      const response = await getCompaniesAPI(query)
      dispatch(getCompaniesSuccess(response?.data?.companies || [], response?.data?.totalCount, response?.data?.page || 0))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getCompaniesFailure(error.message));
    }
  };
};

// Async action creators
const getCompaniesList = () => {
  return async (dispatch: Dispatch) => {
    try {
        dispatch(getCompaniesListRequest());

      const response = await getCompaniesListAPI()
      dispatch(getCompaniesListSuccess(response?.data?.companies))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getCompaniesListFailure(error.message));
    }
  };
};

const getCompany = (uuid: string) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getCompanyRequest());
      const response = await getCompanyAPI(uuid)
      dispatch(getCompanySuccess(response?.data?.company || {}))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getCompanyFailure(error.message));
    }
  };
};

const addCompany = (data: any, navigate: () => void): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(addCompanyRequest());
      
      // Handle FormData object - update startDate and endDate values
      if (data instanceof FormData) {
        const startDate = data.get('startDate');
        const endDate = data.get('endDate');
        
        if (startDate) {
          data.set('startDate', getFirstOfTheDate(startDate).toISOString());
        }
        if (endDate) {
          data.set('endDate', getEndofTheDate(endDate).toISOString());
        }
        
        console.log('Original startDate:', startDate)
        console.log('Transformed startDate:', data.get('startDate'))
        console.log('Original endDate:', endDate)
        console.log('Transformed endDate:', data.get('endDate'))
      } else {
        // Handle JSON object - create copy and transform dates
        const formData = { ...data };
        
        if (formData.startDate) {
          formData.startDate = getFirstOfTheDate(formData.startDate)
        }
        if (formData.endDate) {
          formData.endDate = getEndofTheDate(formData.endDate)
        }
        
        console.log('Original endDate:', data.endDate)
        console.log('Transformed endDate:', formData.endDate)
      }
      
      const response = await addCompanyAPI(data)
      if (response?.status === 200) {
        dispatch(addCompanySuccess());
        dispatch(getCompanies()); // Call the getCompanies action after adding a team
        navigate();
      } else {
        dispatch(addCompanyFailure(response?.message || 'Something went wrong'));
      }
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(addCompanyFailure(error.message));
    }
  };
};

const editCompany = (data: any, uuid: string, navigate: () => void): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(editCompanyRequest());
      const response = await editCompanyAPI(data, uuid )

      if (response?.status === 200) {
        dispatch(editCompanySuccess());
        dispatch(getCompanies()); // Call the getCompanies action after adding a team
        navigate();
      } else {
        dispatch(editCompanyFailure(response?.message || 'Something went wrong'));
      }
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(editCompanyFailure(error.message));
    }
  };
};

const editCompanySub = (data: any, uuid: string, navigate: () => void, type: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {

      console.log(type)
      dispatch(editCompanyRequest());
      data.startDate = getFirstOfTheDate(data.startDate)
      data.endDate = getEndofTheDate(data.endDate)
      const response = type === 'API' ? await editApiCompanySubscriptionAPI(data, uuid ) :await editCompanySubscriptionAPI(data, uuid )

      if (response?.status === 200) {
        dispatch(editCompanySuccess());
        dispatch(getCompanies()); // Call the getCompanies action after adding a team
        navigate();
      } else {
        dispatch(editCompanyFailure(response?.message || 'Something went wrong'));
      }
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(editCompanyFailure(error.message));
    }
  };
};

const addCompanySub = (data: any, navigate: () => void, type: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(editCompanyRequest());
      data.startDate = getFirstOfTheDate(data.startDate)
      data.endDate = getEndofTheDate(data.endDate)
      const response = type === 'API' ? await addApiCompanySubscriptionAPI(data) : await addCompanySubscriptionAPI(data )

      if(response?.status === 200) {
        dispatch(editCompanySuccess());
        dispatch(getCompanies()); // Call the getCompanies action after adding a team
        navigate();
      } else {
        dispatch(editCompanyFailure(response?.message || 'Something went wrong'));
      }
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(editCompanyFailure(error.message));
    }
  };
};

const deleteCompanyWithMove = (id: number, data: DeleteCompanyProps, resetCloseForm: () => void): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  const token = window.localStorage.getItem('token');
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(deleteCompanyRequest());
      await axios.put(
        // `${process.env.REACT_APP_NODE_SERVER_URL}/app/teams/${id}`
        `${process.env.REACT_APP_NODE_SERVER_URL}/app/teams/${id}/delete-and-move-team`,
        data
        ,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(deleteCompanySuccess());
      dispatch(getCompanies()); // Call the getCompanies action after adding a team
      resetCloseForm();
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(deleteCompanyFailure(error.message));
    }
  };
};

const permanentlyDeleteCompany = (uuid: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(deleteCompanyRequest());
      const response = await deleteCompanyAPI(uuid)
      dispatch(deleteCompanySuccess());
      dispatch(getCompanies()); // Call the getCompanies action after deleting
      dispatch(updateDeleteCompanyPopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(deleteCompanyFailure(error.message));
    }
  };
};


const updateDeleteCompanyPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setDeleteCompanyPopup(value))
  };
}

const actions = {
  getCompanies,
  addCompany,
  editCompany,
  getCompany,
  addCompanySub,
  editCompanySub,
  deleteCompanyWithMove,
  permanentlyDeleteCompany,
  updateDeleteCompanyPopup,
  getCompaniesList
}

export default actions
